import styled from 'styled-components'
import FluidImage from '../../../shared/FluidImages'
import 'prismjs/themes/prism.css'

export const Container = styled.div`
  flex: 0 1 100%;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    flex: 0 1 82.9%;
  }
`

export const ContentContainer = styled.div`
  padding-top: 4.8rem;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    border-top: 2px solid ${props => props.theme.colors.cobalt};
  }
`

export const BannerImage = styled(FluidImage)`
  width: 100%;
  margin-bottom: 3.2rem;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    margin-bottom: 5.6rem;
  }
`

export const RelatedArticleHeader = styled.h5`
  margin: 8rem 0 1.6rem;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    margin: 12rem 0 3.2rem;
  }
`

export const Content = styled.div`
  margin: 0 auto;

  h1,
  h2,
  h3 {
    line-height: 1.25;
    margin: 0 0 3.2rem 0;
    text-transform: capitalize;
  }

  h1 {
    font-size: 3.6rem;
  }

  h2 {
    font-size: 2.4rem;
  }

  h3 {
    font-size: 2.0rem;
  }

  p {
    font-size: 1.4rem;
    margin: 0 0 1.6rem 0;

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      font-size: 1.6rem;
    }
  }

  a {
    transition: 0.2s;
    color: ${props => props.theme.colors.base};

    &:hover {
      color: ${props => props.theme.colors.highlight};
    }
  }

  del {
    text-decoration: line-through;
  }

  strong {
    font-weight: 600;
  }

  em {
    font-style: italic;
  }

  ul,
  ol {
    margin: 0 0 2em 0;
  }

  ul {
    li {
      font-size: 1.6rem;
      list-style: disc;
      list-style-position: inside;
      line-height: 1.25;
      &:last-child {
        margin: 0;
      }
    }
  }

  ol {
    li {
      font-size: 1.6rem;
      list-style: decimal;
      list-style-position: inside;
      line-height: 1.25;
      &:last-child {
        margin: 0;
      }
    }
  }

  hr {
    border-style: solid;
    border-color: ${props => props.theme.colors.secondary};
    margin: 0 0 2em 0;
  }

  blockquote {
    border-top: 1px solid ${props => props.theme.colors.cobalt};
    padding: 4rem 0 0;
    margin: 5.6rem 0 4rem;

    p {
      font-size: 2.4rem;
    }

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      margin: 6.4rem 0 8rem;
    }
  }

  pre {
    font-size: 1.4rem;
    margin: 0 0 2em 0;
    border-radius: 2px;
    background: ${props => props.theme.colors.secondary} !important;
    span {
      background: inherit !important;
    }
  }
`
